<mat-form-field class="slider-form-field w-100" appearance="outline">
	<mat-label>{{ labelValue ? labelWithValue : label }}</mat-label>
	<app-slider-form-field
		[formControl]="formControl"
		[min]="min"
		[max]="max"
		[step]="step"
		[discrete]="true"
        [displayWith]="getThumbLabel">
    </app-slider-form-field>
</mat-form-field>
